import { useCoreFetch } from '~/composables/useCoreFetch'

export default defineNuxtPlugin(async () => {
  if (import.meta.env.TEST) return
  await useCoreFetch('/za/warudo/')
})
